import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input } from '@angular/core';

import { Store } from '@ngrx/store';
import { EpcotConfigService, EpcotModule } from 'packages/sports/web/app/src/common/epcot-config.service';

import { BetslipType } from '../../../../core/betslip-type';
import { BetslipPick } from '../../../../core/picks/betslip-pick';
import { PickOddsState } from '../../../../core/picks/pick-models';
import BetslipPickActions from '../../actions';

@Component({
    selector: 'bs-digital-pick-selection',
    templateUrl: './pick-selection.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./pick-selection.component.scss'],
    standalone: false,
})
export default class PickSelectionComponent {
    @Input() selection: { isSelected: boolean; isLocked: boolean };
    @Input() pick: BetslipPick;
    @Input() betslipType?: BetslipType;
    @Input() isLinear: boolean;
    @HostBinding('class') className = 'betslip-digital-pick__selection';
    isEpcotEnabled = this.epcotConfigService.isEnabled(EpcotModule.Betslip);

    constructor(
        private store: Store,
        private epcotConfigService: EpcotConfigService,
        private changeDetector: ChangeDetectorRef,
    ) {}

    get isDisabled(): boolean {
        return this.isLinear && (this.selection.isLocked || this.pick.oddsState !== PickOddsState.Open);
    }

    togglePickSelection(checked: boolean): void {
        if (this.isDisabled || this.selection.isSelected === checked) {
            return;
        }

        if (!this.isLinear || !this.betslipType) {
            this.store.dispatch(BetslipPickActions.togglePick({ pickId: this.pick.id }));

            return;
        }

        this.selection = {
            ...this.selection,
            isSelected: !checked,
        };

        this.store.dispatch(
            BetslipPickActions.togglePickForType({
                pickId: this.pick.id,
                betslipType: this.betslipType,
                newSelectionState: !checked,
            }),
        );
        this.changeDetector.detectChanges();
    }
}
